import { useEffect, useState } from "react";
import CustomInfoDialog from "../components/Dialog";
import MKBox from "../components/MKBox";
import MKButton from "../components/MKButton";
import AuthenticationMKInput from "../layouts/AuthenticationCard/AuthenticationMKInput";
import LivePasswordValidation from "../layouts/AuthenticationCard/LivePasswordValidation";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import api from "../api/api";
import axios from "axios";
import CapsLockIdentifier from "../components/IRAGeneralComponents/UtilComponents/CapsLockIdentifier";

const ChangePasswordSection = () => {
  var validator = require("validator");
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  /* #region Retrieve JWT Access Token  */
  const user = useSelector((state) => state.user);
  const jwtConfig = {
    headers: { Authorization: `Bearer ${user.token}` },
  };
  /* #endregion */

  /* #region Authentication MKInput Variables  */
  const [isHitEnter, setIsHitEnter] = useState(false);
  const [events, setEvents] = useState(null);

  useEffect(() => {
    if (isHitEnter) {
      handleChangePassword();
      setIsHitEnter(false);
    }
  }, [isHitEnter]);
  const [inputs, setInputs] = useState({
    user_name: "",
    old_hash: "",
    new_hash: "",
    confirm_new_hash: "",
  });
  const [mkErrors, setMkErrors] = useState({
    old_hash: { state: false, message: "" },
    new_hash: { state: false, message: "" },
    confirm_new_hash: { state: false, message: "" },
  });
  /* #endregion */

  /* #region CustomInfoDialog  */
  const [openInfoDialog, setOpenInfoDialog] = useState(false);
  const [infoDialogParams, setInfoDialogParams] = useState({
    title: "",
    messageLine1: "",
    type: "info",
    navigateToUrl: "",
  });
  const handleOpenInfoDialog = (title, msg, type, navigateToUrl) => {
    setInfoDialogParams({
      ...infoDialogParams,
      title: title,
      messageLine1: msg,
      type: type,
      navigateToUrl: navigateToUrl,
    });
    setOpenInfoDialog(true);
  };
  /* #endregion */

  const handleChangePassword = async () => {
    setIsLoading(true);
    // CHECK IF PASSWORDS MATCH
    if (inputs.new_hash != inputs.confirm_new_hash) {
      handleOpenInfoDialog(
        "Error",
        "Passwords do not match. Please try again.",
        "error"
      );
      setMkErrors({
        ...mkErrors,
        old_hash: { state: false, message: "" },
        new_hash: { state: true, message: "Passwords do not match" },
        confirm_new_hash: { state: true, message: "Passwords do not match" },
      });
    } else if (inputs.new_hash == inputs.user_name) {
      handleOpenInfoDialog(
        "Error",
        "Password cannot be the same as the username or email.",
        "error"
      );
    } else if (validator.isEmpty(inputs.old_hash.trim())) {
      handleOpenInfoDialog(
        "Error",
        "Please enter your current password",
        "error"
      );
      setMkErrors({
        ...mkErrors,
        old_hash: {
          state: true,
          message: "Please enter your current password",
        },
        new_hash: { state: false, message: "" },
        confirm_new_hash: { state: false, message: "" },
      });
    } else if (validator.isEmpty(inputs.new_hash.trim())) {
      handleOpenInfoDialog("Please enter your new password");
      setMkErrors({
        ...mkErrors,
        old_hash: { state: false, message: "" },
        new_hash: { state: true, message: "Please enter your new password" },
        confirm_new_hash: { state: true, message: "Confirm your new password" },
      });
    } else if (inputs.new_hash === inputs.old_hash) {
      handleOpenInfoDialog(
        "Error",
        "New password cannot be same as the old password.",
        "error"
      );

      setMkErrors({
        ...mkErrors,
        old_hash: { state: false, message: "" },
        new_hash: { state: true, message: "Please enter another new password" },
        confirm_new_hash: { state: true, message: "Confirm your new password" },
      });
    } else {
      var postBody = {
        current_password: inputs.old_hash,
        new_password: inputs.new_hash,
        confirm_password: inputs.confirm_new_hash,
      };

      await axios
        .post(api.femsChangePassword, postBody, jwtConfig)
        .then((res) => {
          handleOpenInfoDialog(
            "Success",
            "You have changed your password successfully, please login.",
            "success",
            "/login"
          );
        })
        .catch((err) => {
          var line = "An error occured while changing password.\n\n";
          if (err.response.status === 401) {
            handleOpenInfoDialog(
              "Error",
              "Permission denied due to invalid token. Please try login again.",
              "error"
            );
          } else if (err.response.data !== null) {
            var ls = err.response?.data?.errors?.error_desc ?? "";

            handleOpenInfoDialog("Error", line + " \n" + ls, "error");
          } else {
            handleOpenInfoDialog("Error", "Unexpected error occured.", "error");
          }
          setIsLoading(false);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
    setIsLoading(false);
  };
  return (
    <>
      <AuthenticationMKInput
        inputType="password"
        inputName={"old_hash"}
        inputLabel={"Old Password"}
        inputs={inputs}
        setInputs={setInputs}
        setEvents={setEvents}
        setIsEnter={setIsHitEnter}
        errorState={mkErrors.old_hash.state}
        errorMessage={mkErrors.old_hash.message}
      />
      <AuthenticationMKInput
        inputType="password"
        inputName={"new_hash"}
        inputLabel={"New Password"}
        inputs={inputs}
        setInputs={setInputs}
        setEvents={setEvents}
        setIsEnter={setIsHitEnter}
        errorState={mkErrors.new_hash.state}
        errorMessage={mkErrors.new_hash.message}
      />
      <AuthenticationMKInput
        inputType="password"
        inputName={"confirm_new_hash"}
        inputLabel={"Confirm New Password"}
        inputs={inputs}
        setInputs={setInputs}
        setEvents={setEvents}
        setIsEnter={setIsHitEnter}
        errorState={mkErrors.confirm_new_hash.state}
        errorMessage={mkErrors.confirm_new_hash.message}
      />
      <CapsLockIdentifier events={events} />
      <MKBox display="flex" justifyContent="center">
        <MKBox mt={4}>
          <MKButton
            onClick={handleChangePassword}
            type="submit"
            color="info"
            size="large"
            fullWidth
            disabled={isLoading}
          >
            Submit
          </MKButton>
        </MKBox>
      </MKBox>
      <LivePasswordValidation
        old_hash={inputs.old_hash}
        hash={inputs.new_hash}
        confirm_new_hash={inputs.confirm_new_hash}
      />
      <CustomInfoDialog
        open={openInfoDialog}
        title={infoDialogParams.title}
        messageLine1={infoDialogParams.messageLine1}
        type={infoDialogParams.type}
        navigateToUrl={infoDialogParams.navigateToUrl}
        setOpenDialog={setOpenInfoDialog}
      />
    </>
  );
};

export default ChangePasswordSection;
